










































import {
  Vue,
  Component
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import BeneficiaryTable from "@/employee/components/settings/BeneficiaryTable.vue";
import { useBankAccountStore } from "@/employee/store/bankAccount";
import { Beneficiary, BeneficiaryRelationshipType, BeneficiaryShare, BeneficiaryStatus, BeneficiaryType, BeneficiaryUpdateRequest } from "@/shared/types";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import EditBeneficiary from "@/employee/components/settings/EditBeneficiary.vue";
import _ from "lodash";

const emptyBeneficiary: Beneficiary = {
  id: 0,
  firstName: "",
  middleInitial: "",
  lastName: "",
  dateOfBirth: "",
  ssn: "",
  address1: "",
  address2: "",
  city: "",
  stateCode: "",
  zip: "",
  share: 0,
  type: BeneficiaryType.None,
  relationshipType: BeneficiaryRelationshipType.None,
  status: BeneficiaryStatus.Active
};

@Component({
  components: {
    GenericLoadingSpinner,
    BeneficiaryTable,
    EditBeneficiary
  }
})

export default class Beneficiaries extends Vue {
  bankAccountStore = useBankAccountStore();
  featureFlagStore = useFeatureFlagStore();

  editBeneficiaryParameters = {
    show: { value: false },
    beneficiary: { ...emptyBeneficiary },
    currentBeneficiaries: [],
    onSave: this.onSaveBeneficiary,
    toggleClose: this.closeEditBeneficiaryForm,
    isNew: true
  };

  mounted (): void {
    this.bankAccountStore.loadBeneficiaries();
  }

  showEditBeneficiaryForm () {
    this.editBeneficiaryParameters.beneficiary = { ...emptyBeneficiary };
    this.editBeneficiaryParameters.currentBeneficiaries = _.cloneDeep(this.activeBeneficiaries);
    this.editBeneficiaryParameters.show.value = true;
  }

  onSaveBeneficiary () {
    return this.bankAccountStore.addBeneficiary(this.buildBeneficiaryAddRequest())
      .then(() => {
        this.editBeneficiaryParameters.show.value = false;
      })
      .catch(() => {/*noop*/ });
  }

  buildBeneficiaryAddRequest (): BeneficiaryUpdateRequest {
    const ob: BeneficiaryShare[] = [];
    this.editBeneficiaryParameters
      .currentBeneficiaries
      .forEach(element => {
        const beneficiaryShare = {
          beneficiaryId: element.id,
          share: element.share
        };
        ob.push(beneficiaryShare);
      });
    return { ...this.editBeneficiaryParameters.beneficiary, beneficiaryShares: ob };
  }

  closeEditBeneficiaryForm () {
    this.editBeneficiaryParameters.show.value = false;
  }

  get profileAddEditEnabled () {
    return this.featureFlagStore.flags.bend17261EnableProfileAddEdit;
  }

  get isLoaded (): boolean {
    return this.bankAccountStore.isBeneficiariesLoaded;
  }

  get beneficiaries (): Beneficiary[] {
    return Object.keys(this.bankAccountStore.beneficiaries).map(key => this.bankAccountStore.beneficiaries[key]);
  }

  get activeBeneficiaries (): Beneficiary[] {
    return this.beneficiaries.filter(x => x.status === BeneficiaryStatus.Active);
  }

  get activePrimaryBeneficiaries (): Beneficiary[] {
    return this.activeBeneficiaries.filter(x => x.type === BeneficiaryType.Primary);
  }

  get activeContingentBeneficiaries (): Beneficiary[] {
    return this.activeBeneficiaries.filter(x => x.type === BeneficiaryType.Contingent);
  }

  get inactiveBeneficiaries (): Beneficiary[] {
    return this.beneficiaries.filter(x => x.status === BeneficiaryStatus.Inactive);
  }

  get inactivePrimaryBeneficiaries (): Beneficiary[] {
    return this.inactiveBeneficiaries.filter(x => x.type === BeneficiaryType.Primary);
  }

  get inactiveContingentBeneficiaries (): Beneficiary[] {
    return this.inactiveBeneficiaries.filter(x => x.type === BeneficiaryType.Contingent);
  }

  get hasActiveBeneficiaries (): boolean {
    return this.isLoaded && this.activeBeneficiaries && this.activeBeneficiaries.length > 0;
  }

  get hasActiveContingentBeneficiaries (): boolean {
    return this.isLoaded && this.activeContingentBeneficiaries && this.activeContingentBeneficiaries.length > 0;
  }

  get hasInactiveBeneficiaries (): boolean {
    return this.isLoaded && this.inactiveBeneficiaries && this.inactiveBeneficiaries.length > 0;
  }

  get hasInactivePrimaryBeneficiaries (): boolean {
    return this.isLoaded && this.inactivePrimaryBeneficiaries && this.inactivePrimaryBeneficiaries.length > 0;
  }

  get hasInactiveContingentBeneficiaries (): boolean {
    return this.isLoaded && this.inactiveContingentBeneficiaries && this.inactiveContingentBeneficiaries.length > 0;
  }
}

